import { Box } from 'rebass'
import { CustomInput } from '../atoms/FormPieces'
import { toast } from 'react-toastify'
import { useMutation } from '@apollo/react-hooks'
import DataFetcher from './DataFetcher'
import gql from 'graphql-tag'
import React, { useState, useEffect } from 'react'

import TeamsTable, { TeamTableLike } from '../molecules/TeamsTable'
import {
  EligibleTeamInfoSeasonFragment as Team,
  useAdminSeasonEligibleTeamsLazyQuery,
} from '../../types/graphql'

const ELIGIBLE_TEAM_INFO = gql`
  fragment eligibleTeamInfoSeason on Team {
    id
    name
    createdAt
    university {
      name
      id
      abbreviation
      state
    }
  }
`
gql`
  query AdminSeasonEligibleTeams($seasonId: ID!, $name: String) {
    season(id: $seasonId) {
      id
      eligibleTeams(name: $name) {
        ...eligibleTeamInfoSeason
      }
    }
  }
  ${ELIGIBLE_TEAM_INFO}
`

const REGISTER_TEAM_MUTATION = gql`
  mutation AdminRegisterTeamForSeason($teamId: ID!, $seasonId: ID!) {
    registerTeamForSeason(teamId: $teamId, seasonId: $seasonId) {
      success
      value
      errors {
        field
        message
      }
    }
  }
`
interface IProps {
  seasonId: string
}

const AdminSeasonTeamsModal: React.FC<IProps> = ({ seasonId }) => {
  const [teams, setTeams] = useState<Team[]>([])
  const [name, setName] = useState('')

  const [registerTeam] = useMutation(REGISTER_TEAM_MUTATION, {
    refetchQueries: ['seasonAdmin', 'AdminSeasonEligibleTeams'],
    onCompleted({ registerTeamForSeason }) {
      if (registerTeamForSeason) {
        if (registerTeamForSeason.success)
          toast.success('Team registered for season', { containerId: 'temporary' })
        else if (registerTeamForSeason.errors)
          registerTeamForSeason.errors.map(
            (e: any) => toast.error(e.message, { containerId: 'temporary' }),
            {
              containerId: 'temporary',
            },
          )
      } else toast.error('Error Registering Team', { containerId: 'temporary' })
    },
  })

  const enrollTeam = (team: TeamTableLike) => {
    registerTeam({ variables: { teamId: team.id, seasonId: seasonId } })
  }

  const [eligibleTeamsQuery, { error, loading }] = useAdminSeasonEligibleTeamsLazyQuery({
    variables: { seasonId: seasonId, name: name },
    fetchPolicy: 'cache-and-network',
    onCompleted: data => {
      if (data && data.season) {
        setTeams(data.season.eligibleTeams)
      }
    },
  })

  useEffect(() => {
    if (!seasonId) {
      return
    }
    eligibleTeamsQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seasonId])

  const handleSearch = (e: any) => {
    eligibleTeamsQuery()
  }

  return (
    <>
      <h2>Search for a team</h2>
      <Box as="form" onSubmit={handleSearch}>
        <CustomInput
          width={[1, 1, 1, 1 / 3]}
          mt={4}
          onChange={e => setName(e.target.value)}
          placeholder="search by name"
        />
        <DataFetcher loading={loading} error={error}>
          <Box mt={6}>
            <TeamsTable
              enrollTeam={enrollTeam}
              teams={teams as TeamTableLike[]}
              coordinator={false}
              enroll={true}
            />
          </Box>
        </DataFetcher>
      </Box>
    </>
  )
}

export default AdminSeasonTeamsModal
